var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.light)?_c('img',{style:(`width: ${_vm.size || '28'}px`),attrs:{"src":`${_vm.base_cdn}/lecard-corporativo/icones/${_vm.name || 'default'}-light.svg`,"alt":"Ícone"}}):_c('img',{style:(`width: ${_vm.size || '28'}px`),attrs:{"src":`${_vm.base_cdn}/lecard-corporativo/icones/${_vm.name || 'default'}.svg`,"alt":"Ícone"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }